<template>
    <v-container app fluid>
        <v-row>
            <v-col cols="10">
                <v-text-field
                    v-model="recipe_name"
                    solo
                    label="Buscar receta"
                    hide-details
                    @keydown="handleInputSearchRecipe"
                >
                </v-text-field>
            </v-col>
            <v-col cols="2">
                <v-btn 
                    dark 
                    height="48" 
                    color="indigo" 
                    class="float-right"
                    @click="handleViewCreate">
                    Nueva
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="3" v-for="recipe in recipes" :key="recipe.id">
                <v-card>
                    <v-card-title class="pt-2 pb-2 recipe-name">
                        <span class="subtitle-2">{{ recipe.name }}</span>
                        <v-spacer></v-spacer>
                        <v-icon dark>
                            fas fa-clipboard-list
                        </v-icon>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-1 pb-1 pl-1 pr-1 list-ingredients">
                        <v-list-item two-line 
                            v-for="ingredient in recipe.ingredients" :key="'i'+ingredient.id"
                            class="item-ingredient">
                            <v-list-item-content class="pt-1 pb-1">
                                <v-list-item-title>
                                    <span class="caption">{{ ingredient.supply.name }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle class="item-quantity">
                                    <v-icon size="14" class="mr-2" color="indigo">
                                        fas fa-tags
                                    </v-icon>
                                    <span class="item-quantity caption font-italic font-weight-bold">{{ ingredient.quantity }}</span>
                                    <span class="ml-1 item-quantity caption font-italic font-weight-bold">{{ ingredient.subunit.abbreviation }}</span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import router from '@/router/index';

export default {
    name: 'RecipesList',
    data () {
        return {
            recipe_name: null
        }
    },
    computed: {
        ...mapState('general', [
            'name_section'
        ]),
        ...mapState('recipes', [
            'recipes'
        ])
    },
    methods: {
        ...mapActions('general', [
            'setNameSection'
        ]),
        ...mapActions('recipes', [
            'getAllRecipes'
        ]),
        handleViewCreate() {
            this.setNameSection('Nueva Receta');
            router.push('/create-recipes');
        },
        handleInputSearchRecipe(KeyboardEvent){
            if (KeyboardEvent.code == 'Enter') {
                this.searchRecipe();
            }
        },
        async searchRecipe () {
            let filters = {
                name: this.recipe_name
            }
            await this.getAllRecipes(filters);
        }
    },
    created () {
        this.getAllRecipes();
    }
}
</script>

<style scoped>
.item-ingredient{
    border-bottom: 1px solid #e0e0e0;
    min-height: 50px !important;
}

.recipe-name{
    background-color: #795548;
    color: #ffffff;
}

.item-quantity{
    color: #4CAF50;
}

.list-ingredients{
    height: 200px;
    overflow-y: auto;
}
</style>